import type { Guide } from '../types';

/** Address, name, search title and description of the guide in each language (menus, cards, links). */
export const jeepGuide: Guide = {
  id: 'jeep',
  imageTour: 'jeep-mata-atlantica',
  published: '2026-10-23',
  updated: '2026-10-23',
  tours: ['jeep-mata-atlantica', 'jeep-mata-atlantica-15823'],
  copy: {
    pt: {
      slug: 'passeio-de-jeep-em-paraty',
      label: 'Passeio de jeep e cachoeiras',
      title: 'Passeio de Jeep em Paraty: Cachoeiras, Alambiques e Caminho do Ouro',
      description: 'Passeio de jeep 4x4 em Paraty por {price:jeep-mata-atlantica} por adulto: Cachoeira da Pedra Branca, Poço do Tarzan com escorregador natural, alambiques de cachaça e casa de farinha. Com busca na pousada.',
    },
    es: {
      slug: 'paseo-en-jeep-en-paraty',
      label: 'Paseo en jeep y cascadas',
      title: 'Paseo en Jeep en Paraty: Cascadas, Alambiques y Camino del Oro',
      description: 'Paseo en jeep 4x4 por Paraty por {price:jeep-mata-atlantica} por adulto: Cachoeira da Pedra Branca, Poço do Tarzan con tobogán natural, alambiques de cachaza y casa de harina. Con búsqueda en tu posada.',
    },
    en: {
      slug: 'paraty-jeep-tour',
      label: 'Jeep tour and waterfalls',
      title: 'Paraty Jeep Tour: Waterfalls, Cachaça Distilleries and the Gold Trail',
      description: 'Paraty 4x4 jeep tour for {price:jeep-mata-atlantica} per adult: the Pedra Branca waterfall, Poço do Tarzan with its natural rock slide, cachaça distilleries and a cassava flour house. Hotel pick-up included.',
    },
    fr: {
      slug: 'excursion-en-jeep-a-paraty',
      label: 'Jeep et cascades',
      title: 'Excursion en Jeep à Paraty : Cascades, Cachaça et Chemin de l’Or',
      description: 'Excursion en jeep 4x4 à Paraty pour {price:jeep-mata-atlantica} par adulte : cascade de Pedra Branca, Poço do Tarzan et son toboggan naturel, distilleries de cachaça et maison de la farine. Prise en charge à l’hôtel.',
    },
  },
};
